import React, { Component } from 'react'
import { Grid , Box} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import VideoPreviewCardBox from './VideoPreviewCardBox'
import useStyles from './styles/VideoCardItemStyle'

class VideoCardItem extends Component {
  // Returns different heights for different CSS breakpoints (more specifically,
  // for different screen widths).
  getVideoPreviewBoxHeight() {
    if (isWidthUp('lg', this.props.width)) {
      return 240
    } else if (isWidthUp('md', this.props.width)) {
      return 320
    } else {
      return 160
    }
  }

  onCardPress() {
    if (this.props.isClickable) {
      this.props.onVideoClicked()
    } else {
      // do nothing
      return
    }
  }

  cardCursor() {
    if (this.props.isClickable) {
      return 'pointer'
    } else {
      return 'auto' // "regular cursor"
    }
  }

  render() {
    const classes = this.props.classes
    return (
      <Grid
        onClick={()=>this.onCardPress()}
        className={classes.itemContainer}
        style={{cursor: this.cardCursor()}}
      >
        <Grid
          container
          className={`${classes.cardContainer} section-horizontal-item-card`}
          direction='column'
        >
          <Grid item>
            <VideoPreviewCardBox
              videoDetails={this.props.videoDetails}
              style={{height: this.getVideoPreviewBoxHeight()}}
            />
          </Grid>
          <Grid
            item
            container
            className={classes.twoVerticalRowsContainer}
            direction="column"
            alignItems="flex-start"
            justify="flex-start"
          >
            <Grid item>
              <Box className={`${classes.mainTitle} section-horizontal-item-title`}>
                {this.props.videoDetails.title}
              </Box>
            </Grid>

            <Grid item>
              <Box className={`${classes.secondaryTitle} section-horizontal-item-subtitle`}>
                {this.props.videoDetails.description}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}
export default withStyles(useStyles)(withWidth()(VideoCardItem))
